import { IconProps } from "../../utils/global-types/global-types";

const CompletedIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_635_22129)">
        <path
          fill="currentColor"
          d="M9.288 1.788c-4.135 0-7.5 3.365-7.5 7.5s3.365 7.5 7.5 7.5 7.5-3.365 7.5-7.5-3.365-7.5-7.5-7.5m4.192 5.526L8.687 12.07a.737.737 0 0 1-1.034.019L5.115 9.777a.76.76 0 0 1-.056-1.053.744.744 0 0 1 1.052-.037l2.012 1.842 4.285-4.286c.301-.3.771-.3 1.072 0 .3.3.3.77 0 1.071"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_635_22129">
          <path fill="#fff" d="M1.788 1.788h15v15h-15z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default CompletedIcon;
